import React from 'react'

export default function DefaultMarker({ id }: any) {
  return (
    <div className='default-marker'>
      <div>{id}</div>
    </div>
  )
}
